/**
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Michał Osadnik osdnk
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React from 'react';
import { View, Platform } from 'react-native';
import Animated from 'react-native-reanimated';
import { Path, Svg, G, Use, Circle, Defs, Filter, FeGaussianBlur, } from 'react-native-svg';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const AnimatedPath = Animated.createAnimatedComponent(Path);
const AnimatedSvg = Animated.createAnimatedComponent(Svg);
const AnimatedCircle = Animated.createAnimatedComponent(Circle);
const AnimatedUse = Animated.createAnimatedComponent(Use);
const strokeWidth = Platform.OS === 'android' ? 5 : 3.32;
const shadowOpacity = Platform.OS === 'android' ? 0.2 : 0.1;
const isWeb = Platform.OS === 'web';
const SvgPath = (props) => {
    const { height, width, animatedPathProps, animatedPathStyle, animatedCurrentPriceCircleProps, animatedStrokeProps, animatedShadowProps, } = props;
    const styles = useStyles(styleSet);
    return (
    // On web the shadow styles become box-shadows around the whole chart rectangle, not the
    // line, so they're left out there and the line gets a blurred copy underneath instead
    <View style={!isWeb && styles.container}>
      <AnimatedSvg height={height + 20} // temporary fix for clipped chart
     viewBox={`0 0 ${width} ${height}`} width={width} style={!isWeb && styles.shadow} fill="none" {...(Platform.OS === 'ios' && {
        animatedProps: animatedShadowProps,
    })}>
        <Defs>
          <AnimatedPath id="chartLine" animatedProps={animatedPathProps} 
    // The style only animates opacity on iOS. On web, react-native-svg can't apply the
    // style array Reanimated passes, which throws before the path's `d` is set.
    {...(Platform.OS === 'ios' && { style: animatedPathStyle })} strokeLinejoin="round"/>
          {isWeb ? (<Filter id="chartLineGlow" x="-10%" y="-20%" width="120%" height="140%">
              <FeGaussianBlur stdDeviation={4}/>
            </Filter>) : null}
        </Defs>
        <AnimatedCircle animatedProps={animatedCurrentPriceCircleProps}/>

        <G>
          {isWeb ? (<AnimatedUse xlinkHref="#chartLine" x={0} y={0} animatedProps={animatedStrokeProps} filter="url(#chartLineGlow)" opacity={0.6}/>) : null}
          <Use xlinkHref="#chartLine" x={0} y={0} strokeWidth={strokeWidth} opacity={shadowOpacity}/>
          <AnimatedUse xlinkHref="#chartLine" x={0} y={0} animatedProps={animatedStrokeProps}/>
        </G>
      </AnimatedSvg>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        shadowRadius: 2,
        shadowOpacity: 0.5,
        shadowColor: colors.shadows.chart,
        shadowOffset: { width: 3, height: 4 },
    },
    shadow: {
        shadowRadius: 5,
        shadowOpacity: 0.5,
        shadowOffset: { width: 0, height: 0 },
    },
}));
export default SvgPath;
